export default __webpack_public_path__ + "static/sgcc-logo-87dd5dd6fdbb5e5a1e30010068d0cdd0.png";